import { Component, EventEmitter } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MaterializeAction } from "angular2-materialize";
import { AuthAndACLService } from './auth_and_acl/authAndACL.service';

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.css'],
  template: `
    <div class="col s12 m4 l3" *ngIf="authAndACL.logado() && !ocultarMenu">
      <app-menu></app-menu>      
    </div>
    <div class="col s12 m8 l9" *ngIf="authAndACL.logado() && !ocultarMenu">
      <section class="content">
        <flash-messages></flash-messages>
        <ng2-toasty [position]="'top-right'"></ng2-toasty>
        
        <router-outlet></router-outlet>

        <div class="fixed-action-btn" style="bottom: 40px; right: 24px;">
          <a class="btn-floating btn-large waves-effect indigo darken-4 modal-trigger" href="#modalAjuda">
            <i class="material-icons">help</i>
          </a>
        </div>

        <div id="modalAjuda" class="modal modal-fixed-footer">
          <div class="modal-content">
            <iframe id="iFrameDuvidasFrequentes"  frameborder="0" width="100%" height="99%" src="https://help-infotic.tic.ufrj.br/duvidas-sistema/SGCD" ></iframe>
          </div>
          <div class="modal-footer" >
            <a (click)="closeModal()"  class="modal-close waves-effect waves-green btn-flat">Fechar</a>
          </div>
        </div>
      </section>
    </div>

    <div class="col s12 m8 l12" *ngIf="!authAndACL.logado() || ocultarMenu">
      <section class="content">
        <flash-messages></flash-messages>
        <ng2-toasty [position]="'top-right'"></ng2-toasty>
        
        <router-outlet></router-outlet>

        <div class="fixed-action-btn" style="bottom: 100px; right: 24px;">
          <a class="btn-floating btn-large waves-effect indigo darken-4 modal-trigger" href="#modalAjuda">
            <i class="material-icons">help</i>
          </a>
        </div>

        <div id="modalAjuda" class="modal modal-fixed-footer">
          <div class="modal-content">
            <iframe id="iFrameDuvidasFrequentes"  frameborder="0" width="100%" height="99%" src="https://help-infotic.tic.ufrj.br/duvidas-sistema/SGCD" ></iframe>
          </div>
          <div class="modal-footer" >
            <a (click)="closeModal()"  class="modal-close waves-effect waves-green btn-flat">Fechar</a>
          </div>
        </div>
      </section>
    </div>
  `
})

export class AppComponent {
  title = 'Sistema de Certificados e Documentos';
  version = '0.1';
  globalActions = new EventEmitter<string|MaterializeAction>();
  ajuda: any = 'https://help-infotic.tic.ufrj.br/ajuda-sistema/SGCD/documentos';
  ocultarMenu = false;

  private rotasSemMenu = ['validar-assinatura', 'validar-certificado'];

  constructor(public authAndACL: AuthAndACLService, private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.ocultarMenu = this.rotasSemMenu.some(rota => event.urlAfterRedirects.startsWith('/' + rota));
      }
    });
  }

  closeModal(): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts